/**
 * @generated SignedSource<<2fb458f109ddd6a644bad4931ef9e306>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountrySelect_data$data = {
  readonly countries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "CountrySelect_data";
};
export type CountrySelect_data$key = {
  readonly " $data"?: CountrySelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"CountrySelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CountrySelect_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "CountryConnection",
      "kind": "LinkedField",
      "name": "countries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CountryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Country",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "countries(first:2147483647)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "47e29b18832bbf44ef54ac1660ee2db3";

export default node;
